import { ETelemetryTopOf } from 'multirpc-sdk';
import { Timeframe } from '@ankr.com/chains-list';

import { selectPublicBlockchainsCountsMap } from 'modules/stats/store/public/selectors';
import { useAppSelector } from 'store/useAppSelector';
import { usePublicStats } from 'modules/stats/hooks/usePublicStats';
import { usePublicStatsParams } from 'modules/chains/hooks/usePublicStatsParams';
import { ALL_CHAINS_LIMIT } from 'modules/stats/const';

export interface IUseChainsStatsProps {
  timeframe: Timeframe;
}

const metrics = [ETelemetryTopOf.BLOCKCHAIN];

export const useChainsPublicStats = ({ timeframe }: IUseChainsStatsProps) => {
  const { publicStatsParams } = usePublicStatsParams({
    metrics,
    timeframe,
    limit: ALL_CHAINS_LIMIT,
  });

  const { loading, params } = usePublicStats(publicStatsParams);

  const chainsCountsMap = useAppSelector(state =>
    selectPublicBlockchainsCountsMap(state, params),
  );

  return { chainsCountsMap, loading, params };
};
